import React, { useState } from 'react';
import {
  GoogleMap,
  Marker,
  InfoWindow,
  useJsApiLoader
} from '@react-google-maps/api';

function TransactionMap({ latitude, longitude, infoLines }) {
  const latNum = parseFloat(latitude);
  const lngNum = parseFloat(longitude);

  const [infoOpen, setInfoOpen] = useState(false);

  const { isLoaded, loadError } = useJsApiLoader({
    id: 'transaction-google-map',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  });

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  const infoWindowOptions = {
    pixelOffset: new window.google.maps.Size(0, -40)
  };

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '400px', margin: '20px 0' }}
      center={{ lat: latNum, lng: lngNum }}
      zoom={13}
    >
      <Marker
        position={{ lat: latNum, lng: lngNum }}
        onClick={() => setInfoOpen(true)}
      />

      {infoOpen && (
        <InfoWindow
          position={{ lat: latNum, lng: lngNum }}
          onCloseClick={() => setInfoOpen(false)}
          options={infoWindowOptions}
        >
          <div className="info-map-window-style">
            {infoLines?.map((line, i) => (
              <div key={i}>{line?.replace(/_/g, ' ')}</div>
            ))}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
}

export default TransactionMap;
